import React from 'react';
import { ajaxPost, AjaxResponseType, SuperagentProgressParams } from '../../common/form/FrekulForm';

export const defaultKaraokeUploadClient = {
  validateFirstKaraokeUpload(uploadHash: string, formData: {
    offvocal_order: string,
    background_order: string,
    promotion: string,
  }): Promise<AjaxResponseType> {
    const postData = { ...formData };
    return ajaxPost(`/karaoke_upload/ajax_validate_first_page/${uploadHash}`, postData, {}, true);
  },
  executeKaraokeUpload(uploadHash: string, formData: {
    offvocal_order: string,
    background_order: string,
    promotion: string,
    song_vocal_off: FileList|null,
    movie: FileList|null,
    song_vocal_on: FileList|null,
    lyrics: string,
  }, progress: (progressInfo: SuperagentProgressParams) => void): Promise<AjaxResponseType> {
    const postData = { ...formData };
    const options = {} as { [key: string]: any };
    if (progress) {
      options.progress = progress;
    }
    return ajaxPost(`/karaoke_upload/ajax_execute/${uploadHash}`, postData, options, true);
  },
  validateLyrics(text: string): Promise<AjaxResponseType> {
    return ajaxPost('/karaoke_upload/ajax_validate_displayable_text', { text }, {}, true);
  },
};

export const KaraokeUploadClientContext = React.createContext(defaultKaraokeUploadClient);

